import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'shared/shared.module';
import { ReceiverActionsComponent } from './receiver-actions.component';


@NgModule({
  imports: [CommonModule, SharedModule],
  declarations: [
    ReceiverActionsComponent,
  ],
  exports: [
    ReceiverActionsComponent,
   ],
  providers: []
})
export class ReceiverActionsModule {}
